<template>
  <!-- layer_wrap : S -->
  <div class="layer_pop_wrap custom">
    <div class='layer_pop_dim' :style="crntObj.openBln? 'display: flex; position: relative;' : 'display: none'">
      <div class="layer_pop md" :class="crntObj.openBln? 'active' : ''" data-role-popup="modal_01" tabindex="0">
        <div class="pop_head">
          <h2>연결리스트</h2>
          <button type="button" class="pop_close" @click="clickCloseHandler">닫기</button>
        </div>
        <div class="pop_cont">
          <div style="margin-bottom: 30px;" v-if="selectedItem.length > 0">
            <font color="red" size="3px">※현재 열람중인 연결 프로토콜</font>
            <div class="tbl_wrap sapce">
                <table class="tbl_style">
                  <colgroup>
                    <col style="width: 10%;">
                    <col>
                    <col style="width: 10%;">
                    <col style="width: 25%;">
                    <col style="width: 25%;">
                  </colgroup>
                  <thead>
                  <tr>
                    <th></th>
                    <th>공정도명</th>
                    <th>공개여부</th>
                    <th>연결자</th>
                    <th>연결일자</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(protocol, i) in selectedItem"
                      :key="i"
                      class="border-bottom cursor-pointer"
                      :style="{ 'background-color: aliceblue' : protocol.checked}"
                  >
                    <td class="py-1 text-center border-right">
                      <input type="checkbox"
                             v-model="protocol.checked"
                             :value="protocol.protocolId"
                      >
                    </td>
                    <td class="py-1 text-center border-right">
                      <span v-html="protocol.processNameKor"></span>
                    </td>
                    <td class="py-1 text-center border-right">
                      {{ (protocol.publicActive? "공개":"비공개")}}
                    </td>
                    <td class="py-1 text-center border-right">
                      {{ protocol.connectLoginId }}<br/>[이름 : {{ protocol.connectUserName }} ]
                    </td>
                    <td class="py-1 text-center border-right">
                      <div>{{ (!protocol.connectDate ? '' : protocol.connectDate) | timeFilter }}</div>
                    </td>
                  </tr>
                  </tbody>
                </table>
            </div>
          </div>

          <div>
            <font color="red" size="3px">※연결되어있는 프로토콜 목록</font>
            <div class="tbl_wrap sapce">
                <table class="tbl_style">
                  <colgroup>
                    <col style="width: 10%;">
                    <col>
                    <col style="width: 10%;">
                    <col style="width: 25%;">
                    <col style="width: 25%;">
                  </colgroup>
                  <thead>
                  <tr>
                    <th></th>
                    <th>공정도명</th>
                    <th>공개여부</th>
                    <th>연결자</th>
                    <th>연결일자</th>
                  </tr>
                  </thead>
                  <tbody v-if="etcList.length > 0">
                  <tr v-for="(protocol, i) in etcList"
                      :key="i"
                      class="border-bottom cursor-pointer"
                      :style="{ 'background-color: aliceblue' : protocol.checked}"
                  >
                    <td class="py-1 text-center border-right">
                      <input type="checkbox"
                             v-model="protocol.checked"
                             :value="protocol.protocolId"
                      >
                    </td>
                    <td class="py-1 text-center border-right">
                      <span v-html="protocol.processNameKor"></span>
                    </td>
                    <td class="py-1 text-center border-right">
                      {{ (protocol.publicActive? "공개":"비공개")}}
                    </td>
                    <td class="py-1 text-center border-right">
                      {{ protocol.connectLoginId }}<br/>[이름 : {{ protocol.connectUserName }} ]
                    </td>
                    <td class="py-1 text-center border-right">
                      <div>{{ (!protocol.connectDate ? '' : protocol.connectDate) | timeFilter }}</div>
                    </td>
                  </tr>
                  </tbody>
                  <tbody v-else-if="!loading">
                  <tr>
                    <td colspan="5">
                      <div class="nodata_txt">
                        <p>연결된 다른 프로토콜이 없습니다.
                        </p>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
            </div>
          </div>

          <div class="login_msg_area">
            <p class="login_msg">여기서 활용이란?</p>
            <!--
                * 1024해상도 아래에서는 tooltip_ico 클릭할 경우 tooltip_box에 active 클래스 추가
            -->
            <div class="tooltip_box">
              <span class="tooltip_ico"></span>
              <div class="tooltip_txt">
                <p>기존 프로토콜을 활용하여 새로운 프로토콜을 생성하는 기능입니다.</p>
              </div>
            </div>
          </div>

        </div>

        <div class="pop_foot">
          <button class="sm_btn color_2" @click="disconnectProtocol">
            프로토콜 연결삭제
          </button>
          <button class="sm_btn color_1" @click="exportProtocol">
            프로토콜 활용<!--내보내기-->
          </button>
<!--          <button class="sm_btn color_1" @click="utilizeProtocol">
            프로토콜 활용
          </button>-->
        </div>
        <Loading :visible="loading"/>
      </div>
    </div>
  </div>
</template>

<script>
import CommNew , {commNewMapMutations, commNewMapGetters} from "@processEditor/CommNew";
import Loading from "@/components/common/loading.vue";
import {v4} from "uuid";

export default {
  components: {
    Loading,
  },
  props: {
    crntObj: Object,
  },
  mixins:[ CommNew ] ,
  data() {
    return {
      loading: false,
      protocolList: [],
      crntProtocol : null,
      processType : null,
    }
  },
  computed: {
    openOrClose(bln) {
      return this.crntObj.openBln;
    },
    selectedItem(){
      return this.protocolList.filter(item => item.protocolId === this.crntProtocol.innerProtocolId);
    },
    etcList(){
      return this.protocolList.filter(item => item.protocolId != this.crntProtocol.innerProtocolId);
    },
    checkIdList(){
      if(this.protocolList != null && this.protocolList.length > 0){
        let checkIdList = new Array();
        this.protocolList.filter(item => item.checked === true).forEach(item => {
          checkIdList.push(item.protocolId);
        })
        return checkIdList;
      }
    }
  },
  async mounted() {

  },
  filters: {
    timeFilter(time) {
      if (time) time = time.replace('T', ' ');
      else time = '';
      return time
    },
  },
  watch: {
    async "crntObj.openBln"(value) {
      this.loading = true;
      try {
        // popup 오픈시 실행.
        if (value) {

          const processDetail = await this.$wApi.process.detail(null, this.$route.query.processId ) ;
          if (processDetail?.error || processDetail == null) {
            window.alert("서버와 통신중 오류가 발생했습니다.<br>잠시후 다시 시도해 주세요.");
            return;
          }
          this.processType = processDetail.processType;

          const { protocols } = this.PROCESS_INFO ;
          this.crntProtocol = protocols.filter(o=>o.id == this.$route.query.protocolId)[0];
          // protocolList setting
          let connectProtocolList = await this.$wApi.protocol.connectProtocoList({protocolId : this.$route.query.protocolId});
          connectProtocolList.forEach(protocol => {
            if(this.crntProtocol.innerProtocolId == protocol.protocolId){
              protocol = {...protocol, checked : true}
            }else{
              protocol = {...protocol, checked : false}
            }
            this.protocolList.push(protocol);
          });
          //console.log("this.protocolList",this.protocolList);
        } else { // popup 닫을시 세팅된 데이터 삭제 및 초기화.
          this.protocolList = [];
        }
      } finally {
        this.loading = false;
      }
    },
  },
  methods: {
    clickCloseHandler(e) {
      e.preventDefault();
      this.crntObj.closeHandler();
    },
    async exportProtocol(){
      if (this.checkIdList.length == 0) {
        alert("내보낼 프로토콜을 체크해주세요.");
        return;
      }

      this.loading = true;
      try {
        const confirmResult = await confirm("내보내진 프로토콜은 연결이 끊어지며 독립적인 프로토콜로 분리됩니다. 선택한 프로토콜을 내보내시겠습니까?") ;
        if (!confirmResult) return;
        const utillizeProtocol = await this.$wApi.protocol.exportProtocol({
          onlyProtocolId: this.$route.query.protocolId,
          exportKeyList: this.checkIdList,
        });

        const protocols = await this.getProtocols();
        this.updateProtocols(protocols);

        if(this.processType == 'NORMAL'){
          let path = '';
          path = '/process/editor';
          this.$router.replace({
            path: path,
            query: {
              processId: this.$route.query.processId,
              editorType: 'process',
            }
          });
        }
        location.reload();
      } catch (error) {
        console.log(error);
      }finally {
        this.loading = false;
      }
    },
    async utilizeProtocol() {
      if (this.checkIdList.length == 0) {
        alert("활용할 프로토콜을 체크해주세요.");
        return;
      }

      this.loading = true;
      try {
        const confirmResult = await confirm("선택된 프로토콜은 독립적인 프로토콜로 분리됩니다. 선택한 프로토콜을 활용하시겠습니까?") ;
        if (!confirmResult) return;
        const utillizeProtocol = await this.$wApi.protocol.utilize({
          onlyProtocolId: this.$route.query.protocolId,
          connectFlag: 2, // 활용!
          keyOfProtocol: v4(),
          utilizeKeyList: this.checkIdList,
          isChangeNode : false,
        });

        const protocols = await this.getProtocols();
        this.updateProtocols(protocols);
        
        await this.$wApi.dictionary.setDictionaryLinkForNewProtocol({
          processId: utillizeProtocol.originProtocolProcessId,
        });

        if(this.processType == 'NORMAL'){
          let path = '';
          path = '/protocol/editor';
          this.$router.replace({
            path: path,
            query: {
              processId: this.$route.query.processId,
              editorType: 'protocol',
              protocolId: utillizeProtocol.originProtocolId,
              keyOfProtocol: utillizeProtocol.originKeyOfProtocol,
            }
          });
        }
        location.reload();
      } catch (error) {
        console.log(error);
      }finally {
        this.loading = false;
      }
    },
    async disconnectProtocol() {
      if (this.checkIdList.length == 0) {
        alert("연결을 삭제할 프로토콜을 체크해주세요.");
        return;
      }

      this.loading = true;
      try {
        const confirmResult = await confirm("원본 프로토콜을 삭제되지 않고 연결 정보만 삭제됩니다.<br/> 연결을 삭제하시겠습니까?") ;
        if (!confirmResult) return;
        let response = await this.$wApi.protocol.disconnectProtocolList({
          disconnectIdList: this.checkIdList
        });
        if (response) {
          location.reload();
        }
      } catch (error) {
        console.log(error);
        this.loading = false;
      } finally {
        this.loading = false;
      }
    },
  }
}
</script>